import React from 'react';
import emblem from '../assets/nk_emblem.png';

// Actual Numerology King sun emblem (provided brand logo, background removed).
export default function SunEmblem({ size = 300 }) {
  return (
    <div className="relative animate-float" style={{ width: size, height: size }}>
      {/* Soft golden halo behind the emblem */}
      <div
        className="absolute inset-[-12%] rounded-full animate-glow"
        style={{
          background:
            'radial-gradient(circle, rgba(255,224,150,0.55) 0%, rgba(255,224,150,0) 62%)',
        }}
      />
      <img
        src={emblem}
        alt="Numerology King emblem"
        className="relative w-full h-full object-contain drop-shadow-[0_10px_25px_rgba(90,13,10,0.35)]"
        draggable={false}
      />
    </div>
  );
}
